class ScrollUtils {
  _scrollTop = 0;

  _scrollLeft = 0;

  viewportHeight = 0;

  viewportWidth = 0;

  setScrollTop(scrollTop) {
    this._scrollTop = scrollTop;
  }

  setScrollLeft(scrollLeft) {
    this._scrollLeft = scrollLeft;
  }

  calculateFirstRow = (scrollTop, cellHeight) => {
    return scrollTop / cellHeight;
  };

  calculateFirstCell = (scrollLeft, cellWidth) => {
    return scrollLeft / cellWidth;
  };

  calculateCellHeight = (viewOptions) => {
    return viewOptions.cellHeight;
  };

  calculateCellWidth = (viewOptions) => {
    return viewOptions.cellWidth;
  };
}

export default new ScrollUtils();
